import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const ProduccionReportadaApi = () => {
    const [cargando, setCargando] = useState(false);

    const getProduccionTurno = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "produccion_reportada/get_produccion_turno",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getProductosTerminados = async (params) => {
        return api
            .get("produccion_reportada/productos_en_produccion", params)
            .then((data) => {
                if (data) return data;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const registrarEnvio = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("produccion_reportada", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deleteEnvio = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`produccion_reportada/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getProduccionTurno,
        getProductosTerminados,
        registrarEnvio,
        deleteEnvio,

        cargando,
    };
};
